import React from "react";
import { Grid, Box, Typography } from "@material-ui/core";

const AssetTypeNotSupported = () => {
	return (
		<Box>
			<Grid container direction="row" alignItems="flex-end">
				<Grid item xs={12} align="center">
					<Typography variant="h5"> Asset Type Not Supported.</Typography>
				</Grid>
			</Grid>
		</Box>
	);
};
export default AssetTypeNotSupported;
